import React from 'react'
import loadable from '@loadable/component'

const Markdown = loadable(() => import('markdown-to-jsx'))

function Paragraph({ children, className }: { children: React.ReactNode; className?: string }) {

  return (
    <Markdown className={className} options={{ wrapper: 'p', forceWrapper: true }}>
      {String(children)}
    </Markdown>
  )
}

Paragraph.defaultProps = {
  className: ''
}

function Heading({
  children,
  className,
  as = 'h2'
}: {
  children: React.ReactNode
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}) {
  return (
    <Markdown className={className} options={{ wrapper: as, forceWrapper: true, forceInline: true }}>
      {String(children)}
    </Markdown>
  )
}

Heading.defaultProps = {
  className: '',
  as: 'h2'
}

export { Paragraph, Heading }

